<template>
  <div class="level">
    <LevelRow
      @toggle="openUrl"
      :hasAccess="hasAccess"
      contentType="link"
      :contentId="content.uuid"
      :status="contentStatus"
      :statusText="statusText"
      :parentStatus="parentStatus"
      :title="content.name"
      :plansLink="plansLink"
      :isWatching="false"
      :details="[content.link]"
      :progress="progress"
      @click.native="openUrl"
    >
    </LevelRow>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CONSTANTS from '@/constants'
import LevelRow from '@/components/content/level/LevelRow.vue'

export default {
  name: 'LinkLevel',
  data() {
    return {
      isLoading: false,
    }
  },
  components: {
    LevelRow,
  },
  props: {
    parentStatus: {
      type: String,
      required: true,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
    content: {
      type: Object,
      required: true,
    },
    contentStatus: {
      type: String,
      required: true,
    },
    contentType: {
      type: String,
      required: true,
    },
    plansLink: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      currentParent: state => state.content.currentParent,
    }),
    isLinkVisited() {
      return (
        this.contentStatus &&
        this.contentStatus === CONSTANTS.CONTENT_USER_STATUS.VISITED
      )
    },
    progress() {
      return 0
    },
    statusText() {
      if (this.contentStatus === CONSTANTS.CONTENT_USER_STATUS.VISITED) {
        return `Revisit URL`
      }
      return `Visit URL`
    },
    mixpanelEventPayload() {
      const payload = {
        link_id: this.content.uuid,
        link_name: this.content.name,
        link_context: CONSTANTS.PARENT_CONTENT_TYPES_KEYS.PLAYLIST,
        link_status: this.content.status,
        playlist_id: this.currentParent?.id,
        playlist_name: this.currentParent?.name,
        type: this.content.type,
      }
      return payload
    },
  },
  methods: {
    async setLinkStatus(status = CONSTANTS.CONTENT_USER_STATUS.VISITED) {
      try {
        await this.$store.dispatch('content/updateLinkStatus', {
          linkId: this.content.uuid,
          status,
        })
        this.sendMixpanelEvent(
          this.eventsConstants.CONTENT_LINK_VISITED,
          this.mixpanelEventPayload
        )
      } catch (err) {
        return err
      }
    },
    async openUrl() {
      if (this.hasAccess) {
        this.$emit('toggle-content', CONSTANTS.PLAYLIST_CONTENT_TYPES.LINK)
        this.setLinkStatus()
        window.open(this.content.link, '_blank')
      }
    },
  },
}
</script>
